export default "__VITE_ASSET__Bojn3bmg__"